export const announce = {
    "announcement": {
        "announcement01": "公告日期",
        "announcement02": "公告標題",
        "announcement03": "公告事項",
        "announcement04": "附件",
        "announcement05": "公告填寫-新增",
        "announcement06": "公告填寫-修改"
    }
}